/* eslint-disable react/no-array-index-key */
import _ from 'lodash';
import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { HBox, VBox } from '../../../components/Box';
import { selectWorks } from '../../Api/selectors';
import { fromAutotelex } from '../actions';
import { REQUEST_VEHICLE_FROM_AUTOTELEX, VEHICLE_OPTIONS } from '../constants';
import { selectAllOptions } from '../selectors';
import { Check } from '../../../components/Icon';
import { GeneratePdfButton } from '../../../components/GeneratePdfButton/GeneratePdfButton';
import { CompanyLabelById } from '../../Companies/components/CompanyLabelById';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBan, faCheck } from '@fortawesome/free-solid-svg-icons';

const Container = styled.div`
  max-width: 1280px;
  .image {
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    width: 300px;
    min-width: 300px;
    height: 300px;
    min-height: 300px;
    &.large {
      width: 700px;
      min-width: 700px;
      height: 400px;
      min-height: 400px;
    }

    &.thumb {
      width: 200px;
      height: 180px;
      min-width: 200px;
      min-height: 180px;
    }

    &.incident-detail {
      width: 120px;
      height: 90px;
      min-width: 120px;
      min-height: 90px;
    }
  }

  .thumbs {
    width: 100%;
  }
`;

const Pane = styled.div`
  background-color: white;
  border: 2px solid grey;

  .title {
    font-size: 26px;
    color: black;
    text-transform: uppercase;
    font-weight: 600;
    line-height: 24px;
  }

  .sub-title {
    color: black;
    text-transform: capitalize;
    font-weight: 600;
  }
  .info {
    font-size: 14px;
    font-weight: 600;
    color: black;
    max-width: 100%;
  }

  padding: 16px;
`;

const Table = styled.div`
  display: table;
  width: 100%;
  > div {
    display: table-row;
    > div {
      display: table-cell;
      padding: 12px;
      border-bottom: 1px solid #ddd;

      white-space: nowrap;

      &:first-child {
        font-size: 15px;
        font-weight: 600;
        color: black;
      }

      &:last-child,
      &.header {
        text-align: left;
        font-size: 14px;
        font-weight: 600;
        color: black;
      }

      &:last-child {
        max-width: 180px;
        overflow: hidden;
        ,
        span {
          white-space: wrap;
        }
      }

      &.option-name {
        text-align: left;
        color: #999;
      }

      &.option-title {
        text-align: left;
      }
    }
    &:last-child {
      > div {
        border-bottom: none;
      }
    }
  }
`;

/* eslint-disable react/prefer-stateless-function */
class VehicleDetailsInspectionType2Comp extends BaseComponent {
  constructor(props) {
    super(props, {});
  }

  get vehicle() {
    return this.props.vehicle;
  }

  get tires() {
    let results = Object.keys(this.vehicle)
      .filter(key => key.indexOf('tire_set_') === 0)
      .map(key => this.vehicle[key].split(':'))
      .map((pairs, index) => ({
        id: index,
        weather: pairs[0],
        material: pairs[1],
        inch: pairs[2],
        mm: [pairs[3], pairs[4], pairs[5], pairs[6]],
      }));

    return results;
  }

  fromAutoTelex() {
    this.props.fromAutoTelex();
  }

  renderImageByType(type, className, key) {
    return (
      <div
        key={key}
        className={`image ${className || ''}`}
        style={{ backgroundImage: `url("${this.vehicle.documents.find(d => d.type == type)?.url}")` }}
        // style={{ backgroundImage: `url("http://idwe.test/storage//documents//e3615390-d020-4193-a694-32c029eb7b07.jpg")` }}
      ></div>
    );
  }

  renderImage(doc, className, key) {
    console.log("doc", doc.url); // Log before returning JSX

    return <div key={key} className={`image ${className || ''}`} style={{ backgroundImage: `url("${doc.url}")` }}></div>;
  }

  //get all acceptable / not acceptable incidents
  inspectionIncidents(acceptable, sum) {
    let result = Object.keys(this.vehicle)
      .filter(name => name.indexOf('inspection_attention_incident_') === 0)
      .map(key => this.vehicle[key])
      .filter(incident => incident?.acceptable == acceptable);

    if (sum) {
      result = _.sumBy(result, i => parseInt(i.cost?.replace(/\D/g, ''), 10));
      return `€ ${result},00`;
    }

    return result.map(incident => ({
      ...incident,
      type: incident.type ? this.lbl(`inspection.attention.type.${incident.type}`) : '',
      solution: incident.solution ? this.lbl(`inspection.attention.solution.${incident.solution}`) : '',
      part: incident.part ? this.lbl(`inspection.attention.part.${incident.part}`) : '',
      cost: incident.cost ? `€ ${incident.cost},00` : '',
    }));
  }

  inspectionIncidentPhotos(incidentId) {
    let result = this.vehicle.documents.filter(
      document => document.type == `photo_interior_inspection_incident_${incidentId}`,
    );
    return result;
  }

  render() {
    const v = this.vehicle;
    console.dir(v);
    return (
      <Container>
        <VBox id={'Inspection_report_V2'} gap={12} style={{ padding: '16px' }}>
          <HBox left gap={12}>
            <Pane style={{ width: '40%' }}>
              <div className="title" style={{ paddingLeft: '10px' }}>
                {v.brand_name}
              </div>
              <div className="info" style={{ paddingLeft: '10px' }}>
                {v.model_info}
              </div>
              <div>{this.renderImageByType('photo_interior_import_0 impression_left_front', 'thumb')}</div> 
              <Table className="info">
                <div>
                  <div>{this.lbl('vehicle.property.regplate')}</div>
                  <div>{v.regplate}</div>
                </div>

                <div>
                  <div>{this.lbl('vehicle.property.vin')}</div>
                  <div>{v.vin}</div>
                </div>

                <div>
                  <div>{this.lbl('vehicle.property.inspector')}</div>
                  <div>{v.inspector_user_name}</div>
                </div>

                <div>
                  <div>{this.lbl('vehicle.property.inspection_date')}</div>
                  <div>{v.inspection_date}</div>
                </div>

                <div>
                  <div>{this.lbl('vehicle.property.location')}</div>
                  <div>
                    <CompanyLabelById company_id={v.inspection_location_company_id} />
                  </div>
                </div>

                <div>
                  <div>{this.lbl('vehicle.property.creditor_company')}</div>
                  <div>
                    <CompanyLabelById company_id={v.creditor_company} />
                  </div>
                </div>
              </Table>
            </Pane>
            <Pane style={{ width: '60%' }}>
              <div className="sub-title">{this.lbl('details')}</div>
              <HBox>
                <Table className="info">
                  <div>
                    <div>{this.lbl('vehicle.property.brand_name')}</div>
                    <div>{v.brand_name}</div>
                  </div>
                  <div>
                    <div>{this.lbl('vehicle.property.model_name')}</div>
                    <div>{v.model_name}</div>
                  </div>
                  <div>
                    <div>{this.lbl('vehicle.property.date_first_allowance')}</div>
                    <div>{v.date_first_allowance}</div>
                  </div>
                  <div>
                    <div>{this.lbl('vehicle.property.transmission_type')}</div>
                    <div>{this.lbl(`vehicle.property.transmission_type.${v.transmission_type}`)}</div>
                  </div>
                  <div>
                    <div>{this.lbl('vehicle.property.fuel_type')}</div>
                    <div>{this.lbl(`vehicle.property.fuel_type.${v.fuel_type}`)}</div>
                  </div>
                  <div>
                    <div>{this.lbl('vehicle.property.mileage')}</div>
                    <div>{v.mileage}&nbsp;km</div>
                  </div>
                </Table>
                <Table className="info">
                  <div>
                    <div>{this.lbl('vehicle.property.financial_bpm_gross')}</div>
                    <div>{v.financial_bpm_gross}</div>
                  </div>
                  <div>
                    <div>{this.lbl('vehicle.property.rest_bpm')}</div>
                    <div>{v.rest_bpm}</div>
                  </div>
                  <div>
                    <div>{this.lbl('vehicle.property.tax_type')}</div>
                    <div>{v.tax_type}</div>
                  </div>
                  <div>
                    <div>{this.lbl('vehicle.property.num_keys')}</div>
                    <div>{v.num_keys}</div>
                  </div>
                  <div>
                    <div>{this.lbl('vehicle.property.date_last_maintenance')}</div>
                    <div>{v.date_last_maintenance}</div>
                  </div>
                  <div>
                    <div>{this.lbl('vehicle.property.mileage_last_maintenance')}</div>
                    <div>{v.mileage_last_maintenance}</div>
                  </div>
                  <div>
                    <div>{this.lbl('vehicle.property.apk_expiry')}</div>
                    <div>{v.date_apk_expiry}</div>
                  </div>
                </Table>
              </HBox>
            </Pane>
          </HBox>
          <HBox gap={24} left>
            {this.renderImageByType('photo_interior_import_0 impression_left_front', 'large')}
            <HBox flexWrap gap={24} className="thumbs">
              {[
                'photo_interior_import_0 impression_right_front',
                'photo_interior_import_0 impression_right_back',
                'photo_interior_import_0 impression_left_back',
                'photo_interior_import_0 impression_interior_full',
                'photo_interior_import_0 impression_mileage',
                'photo_interior_import_0 impression_interior_side',
              ].map((name, index) => this.renderImageByType(name, 'thumb', `main-photo${index}`))}
            </HBox>
          </HBox>

          <HBox gap={12}>
            <VBox gap={12}>
              <Pane style={{ width: '100%' }}>
                <div className="sub-title">
                  <FontAwesomeIcon icon={faBan} size="lg" color="red" />
                  &nbsp; Samenvatting niet acceptabele schades
                </div>
                <Table>
                  <div>
                    {['part', 'type', 'solution', 'cost'].map(name => (
                      <div key={name} className="header">
                        {this.lbl(`inspection.attention.${name}`)}
                      </div>
                    ))}
                  </div>
                  {this.inspectionIncidents(false).map(incident => (
                    <div key={`inspection-incident-${incident.id}`}>
                      {['part', 'type', 'solution', 'cost'].map(prop => (
                        <div key={`i-${incident.id}-${prop}`}>{incident[prop]}</div>
                      ))}
                    </div>
                  ))}
                  <div>
                    <div>&nbsp;</div>
                    <div>&nbsp;</div>
                    <div className="info">total</div>
                    <div>{this.inspectionIncidents(false, true)}</div>
                  </div>
                </Table>
              </Pane>{' '}
              <Pane style={{ width: '100%' }}>
                {this.inspectionIncidents(false).map(incident => (
                  <div className="header" key={`inspection-incident-detailed-${incident.id}`}>
                    <div className="sub-title">Details niet acceptable schade {incident.id}</div>
                    <Table>
                      <div>
                        {['part', 'type', 'solution', 'cost'].map(name => (
                          <div key={name} className="header">
                            {this.lbl(`inspection.attention.${name}`)}
                          </div>
                        ))}
                      </div>
                      <div>
                        {['part', 'type', 'solution', 'cost'].map(prop => (
                          <div key={`i-${incident.id}-${prop}`}>{incident[prop]}</div>
                        ))}
                      </div>
                    </Table>
                    {incident.remarks ? <div>{incident.remarks}</div> : null}
                    <HBox flexWrap gap={12} left>
                      {this.inspectionIncidentPhotos(incident.id).map(doc =>
                        this.renderImage(doc, 'incident-detail', `incident-detail-${incident.id}`),
                      )}
                    </HBox>
                    <div>
                      <br />
                    </div>
                  </div>
                ))}
              </Pane>
              <Pane style={{ width: '100%', marginTop: '40px' }}>
                <div className="sub-title">
                  <FontAwesomeIcon icon={faCheck} size="lg" color="green" />
                  &nbsp; Samenvatting acceptabele schades
                </div>
                <Table>
                  <div>
                    {['part', 'type', 'solution', 'cost'].map(name => (
                      <div key={name} className="header">
                        {this.lbl(`inspection.attention.${name}`)}
                      </div>
                    ))}
                  </div>
                  {this.inspectionIncidents(true).map(incident => (
                    <div key={`inspection-incident-${incident.id}`}>
                      {['part', 'type', 'solution', 'cost'].map(prop => (
                        <div key={`i-${incident.id}-${prop}`}>{incident[prop]}</div>
                      ))}
                    </div>
                  ))}
                  <div>
                    <div>&nbsp;</div>
                    <div>&nbsp;</div>
                    <div className="info">total</div>
                    <div>{this.inspectionIncidents(true, true)}</div>
                  </div>
                </Table>
              </Pane>{' '}
              <Pane style={{ width: '100%' }}>
                {this.inspectionIncidents(true).map(incident => (
                  <div key={`inspection-incident-detailed-${incident.id}`}>
                    <div className="sub-title">Details acceptabele schade {incident.id}</div>
                    <Table>
                      <div>
                        {['part', 'type', 'solution', 'cost'].map(name => (
                          <div key={name} className="header">
                            {this.lbl(`inspection.attention.${name}`)}
                          </div>
                        ))}
                      </div>
                      <div>
                        {['part', 'type', 'solution', 'cost'].map(prop => {
                          return <div key={`i-${incident.id}-${prop}`}>{incident[prop]}</div>;
                        })}
                      </div>
                    </Table>

                    {incident.remarks ? <div>{incident.remarks}</div> : null}
                    <HBox flexWrap gap={12} left>
                      {this.inspectionIncidentPhotos(incident.id).map(doc =>
                        this.renderImage(doc, 'incident-detail', `incident-detail-${incident.id}`),
                      )}
                    </HBox>
                    <div>
                      <br />
                    </div>
                  </div>
                ))}
              </Pane>
            </VBox>
            <VBox gap={12}>
              {this.tires.map((tire, index) => (
                <Pane style={{ width: '100%' }} key={`tire-${tire.id}`}>
                  <div className="sub-title">{this.lbl(`inspection.v2.tireset.${tire.id}`)}</div>

                  <HBox>
                    <Table>
                      {['lf', 'rf', 'lb', 'rb'].map((pos, i2) => (
                        <div key={`tire.${tire.id}.${pos}`}>
                          <div>{this.lbl(`vehicle.property.tire_set.${pos}`)}</div>
                          <div>{this.lbl(`vehicle.property.tire_set.material.${tire.material}`)}</div>
                          <div>{tire.inch}&quot;</div>
                          <div>{tire.mm[i2]}mm</div>
                          <div>{this.lbl(`vehicle.property.tire_set.weather.${tire.weather}`)}</div>
                        </div>
                      ))}
                    </Table>
                  </HBox>
                  <VBox style={{ width: 'auto', maxWidth: '100%' }}>
                    {v.documents
                      .filter(doc => {
                        return doc.type && doc.type.indexOf('photo_interior_tires_tire_set_' + tire.id) == 0;
                      })
                      .map(doc => this.renderImageByType(doc.type, 'thumb'))}
                  </VBox>
                </Pane>
              ))}
              <Pane style={{ width: '100%' }}>
                <div className="sub-title">{this.lbl('vehicle.details.options.title')}</div>
                <Table>
                  {VEHICLE_OPTIONS.map((value, index) => {
                    if (value.title)
                      return (
                        <div key={index}>
                          <div className="sub-title option-title">{this.lbl(`vehicle.options.${value.title}`)}</div>
                        </div>
                      );

                    let active = v.options.find(o => o.name == value);
                    if (active)
                      return (
                        <div key={active.id}>
                          <div className="option-name">
                            <div style={{ color: '#0BCF97', display: 'inline' }}>
                              <Check />
                            </div>
                            {active.name}
                          </div>
                        </div>
                      );

                    return null;
                  })}
                </Table>
              </Pane>
            </VBox>
          </HBox>
        </VBox>
        <HBox>
          <GeneratePdfButton sectionId={'Inspection_report_V2'} label={this.lbl('inspection.v2.pdf')} />
        </HBox>
      </Container>
    );
  }
}

VehicleDetailsInspectionType2Comp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    work: selectWorks([REQUEST_VEHICLE_FROM_AUTOTELEX + ownProps.vehicle.id]),
    allOptions: selectAllOptions(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    fromAutoTelex(callback) {
      dispatch(fromAutotelex(ownProps.vehicle.id, null, callback));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const VehicleDetailsInspectionType2 = compose(withConnect, withRouter)(VehicleDetailsInspectionType2Comp);
